module.exports = __webpack_public_path__ + "media/budapest/church_castle-747e182f.jpg";